import "./styles.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import useAuthStore from "@/hooks/useAuthStore";
import useDashboardStore from "@/hooks/useDashboardStore";
import translations from "@/config/translations";

export default function SelectStoreScreen() {
    const { lang } = useLangStore();
    const { client } = useAuthStore();
    const { setStore } = useDashboardStore();
    const navigate = useNavigate();
    const t = translations[lang ?? "ar"].selectStore;

    const ownedStores: any[] = client?.owner ?? [];
    const permissionStores: any[] = (client?.permissions ?? []).map((p: any) => p.store).filter((s: any) => s && typeof s === "object");

    const allStores = [...ownedStores, ...permissionStores].reduce((acc: any[], store: any) => {
        if (store?._id && !acc.some((s) => s._id === store._id)) acc.push(store);
        return acc;
    }, []);

    useEffect(() => {
        if (allStores.length === 1) {
            setStore(allStores[0]._id, allStores[0]);
            navigate("/");
        }
    }, []);

    const handleSelect = (store: any) => {
        setStore(store._id, store);
        navigate("/");
    };

    const getStoreName = (store: any): string => {
        if (!store?.name) return "—";
        if (typeof store.name === "string") return store.name;
        if (Array.isArray(store.name)) {
            const match = store.name.find((n: any) => n.lang === lang) ?? store.name[0];
            return match?.value ?? "—";
        }
        return "—";
    };

    if (allStores.length === 1) return null;

    return (
        <div className="select-store-screen">
            <div className="select-store-header">
                <p className="select-store-title">{t.title}</p>
                <p className="select-store-subtitle">{t.subtitle}</p>
            </div>
            <div className="select-store-list">
                {allStores.map((store) => {
                    const name = getStoreName(store);
                    const firstLetter = name !== "—" ? name.charAt(0) : "?";
                    return (
                        <button key={store._id} className="store-card" onClick={() => handleSelect(store)}>
                            <div className="store-card-logo-wrap">
                                {store.logo ? (
                                    <img className="store-card-logo" src={store.logo} alt={name} />
                                ) : (
                                    <span className="store-card-logo-placeholder">{firstLetter}</span>
                                )}
                            </div>
                            <div className="store-card-info">
                                {store.type && <p className="store-card-type">{store.type}</p>}
                                <p className="store-card-name">{name}</p>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
